export default "__VITE_ASSET__$dWs5Dxc__"